const admin = 'api/v1/admin/';
export const memberSupport = `${admin}member_support/`;

export const apiPaths = {
  admin,
  payments: 'paysafe/admin/',
  member: `${memberSupport}users`,
  memberGroup: `${memberSupport}user_groups`,
  memberPromotions: `${memberSupport}promotions`,
  memberSupport,
  memberTransactions: `${memberSupport}users`,
  models: `${admin}models/`,
  resolutions: `${memberSupport}resolutions`
};
